export const PUBLIC_CLAIM_ENDPOINTS = {
  evidencePolicy: '/public/claims/evidence-policy',
  /**
   * Matches an order to a store. Sent with a `formSlug` from a merchant link,
   * and without one from the generic /file-a-claim route — where the server
   * resolves the merchant from the order number and email instead.
   */
  verifyOrder: '/public/claims/verify-order',
  submit: '/public/claims',
  track: '/public/claims/track',
  supportContact: '/public/claims/support-contact',
  evidence: '/public/claims/evidence',
} as const;
